import { Component, Input, OnInit } from "@angular/core";
import { AuthService } from "@sicapes/auth";
import { ConfirmationService } from "primeng/api";
import { RecursoService } from "src/app/shared/service/inscricao/recurso.service";

@Component({
    selector: 'app-dashboard-ocorrencia',
    templateUrl: './dashboard-ocorrencia.component.html',
    styleUrls: ['./dashboard-ocorrencia.component.less'],
    providers: [ConfirmationService]
})
export class DashboardOcorrencia implements OnInit {
    TIPO_ATIVO = 'ATIVO';
    TIPO_ENVIADO = 'ENVIADO';
    TIPO_EXPIRADO = 'EXPIRADO';
    pareceresEmitidos: any[] = [];
    parecerEtapaNome = '';

    @Input() ocorrencias: any;


    constructor(protected recursoService: RecursoService, protected authService: AuthService) { }
    ngOnInit(): void {


        // TODO: O QUE GERE O SIMULADOR DE ACESSO NÃO PODE FICAR EM CADA COMPONENTE, DEVE SER ALGUM INTERCEPTOR QUE DEVE GERENCIAR
        this.authService.currentUser.subscribe((x: any) => {
            if (('corporativo' in x) &&
                ('pessoaLogada' in x) &&
                x.corporativo.codigo !== x.pessoaLogada.codigo) {
                this.recursoService.simuladorAcesso = btoa(x.corporativo.codigo);
            } else {
                this.recursoService.simuladorAcesso = null;
            }
            this.recursoService.getReconsideracaoAtiva().subscribe(
                (t) => { console.log(this.recursoService.simuladorAcesso); console.log(t) },
                (err) => { },
                () => { });
        });
    }

    public porTipoOcorrencia = (ocorrencias, tipo): any[] => {
        let retorno = [];
        if (tipo == this.TIPO_ATIVO) {
            retorno = ocorrencias.filter(o => !o.expirado && o.reconsideracaoInformacao.filter((ri) => !ri.submetido).length > 0
            )
        }
        if (tipo == this.TIPO_ENVIADO) {
            retorno = ocorrencias.filter(o => o.reconsideracaoInformacao.filter((ri) => ri.submetido).length > 0)
        }
        if (tipo == this.TIPO_EXPIRADO) {
            retorno = ocorrencias.filter(o => o.expirado)
        }
        return retorno;
    }

    public preencherRecurso = (ocorrencia: any) => {
        this.recursoService.setReconsideracaoAtiva(ocorrencia)
    }

    public listarDocumentos = (ocorrencia: any, lista = null): void => {
        if (!ocorrencia.triggered && ocorrencia.triggered == false) {
            ocorrencia.triggered = true
            this.recursoService.obterDocumentosReconsideraco(ocorrencia.reconsideracaoOcorrencia.idOcorrencia, ocorrencia.reconsideracaoOcorrencia.idEtapaAnalise).subscribe(
                (response) => {
                    //@ts-ignore
                    ocorrencia.documentos = response._embedded.items;
                },
                (err) => { },
                () => { }
            );
        }
        if (!ocorrencia.triggered)
            ocorrencia.triggered = false

    }


    public documentosEmitidos = (reconsideracao: any) => {
        this.pareceresEmitidos = [];
        this.recursoService.obterDocumentosParecer(reconsideracao.reconsideracaoOcorrencia).subscribe((response: any) => {
            this.pareceresEmitidos = response._embedded.items;

            console.log(this.pareceresEmitidos);

            this.pareceresEmitidos.sort((a, b) => {
                if (a.nomeEtapa > b.nomeEtapa) return 1;
                if (a.nomeEtapa < b.nomeEtapa) return -1;
                return 0;
            });
        },
            (err) => { },
            () => { });
    }
    public downloadDocumentoParecer = (documentoParecer) => {
        this.recursoService.downloadDocumentosParecerAnalise(documentoParecer).subscribe((response: any) => {
            // window.open(response.arquivo, "pdf");

            let pdfWindow = window.open("");
            pdfWindow.document.write(
                "<iframe width='100%' height='100%' src='" + response.arquivo + "'></iframe>"
            )
        },
            (err) => { },
            () => { });
    }

    public fecharModalPareceresEmitidos = () => {
        this.pareceresEmitidos = [];
    }

    //
}